<template lang="pug">
  .page.profile-page
    header.page__header.profile-page__header
      main-header(
        @onCloseModal="closeModal"
      )
    .profile-page__container
      aside.profile-page__aside
        side-nav(
        :sideNavData="sideNavData"
        )
      main.profile-page__main
        router-view(
          @onOpenModal="openModal"
          @onCloseModal="closeModal"
        )
    footer.page__footer
      main-footer
</template>

<script>
import MainHeader from "../../components/main-header/main-header";
import MainFooter from "../../components/main-footer/main-footer";
import SideNav from "../../components/side-nav/side-nav";

export default {
  name: "UserPage",
  components: {
    SideNav,
    MainFooter,
    MainHeader,
  },
  data() {
    return {
      sideNavData: [
        {
          path: "/user/profile",
          text: "Профиль",
        },
        {
          path: "/user/requests",
          text: "Заявки",
        },
        {
          path: "/user/settings",
          text: "Настройки аккаунта",
        },
        {
          path: "/user/feedback",
          text: "Обратная связь",
        },
      ],
    };
  },
  methods: {
    openModal(mode, data) {
      this.$root.$emit("onOpenModal", mode, data);
    },
    closeModal() {
      this.$root.$emit("onOpenModal", "mode", "data", "close");
    },
  },
};
</script>
